import { ItemBasicDto } from '@order-mage/integration-sdk';
import { Media } from '@/shared/ui/media/types';

// TODO: Replace later with real data
export enum Language {
    CS = 'CS',
    SK = 'SK',
    EN = 'EN',
    EN_GB = 'EN_GB',
    EN_US = 'EN_US',
    EN_AU = 'EN_AU',
    EN_CA = 'EN_CA',
    EN_NZ = 'EN_NZ',
    EN_IE = 'EN_IE',
    EN_ZA = 'EN_ZA',
    EN_IN = 'EN_IN',
    EN_SG = 'EN_SG',
    EN_HK = 'EN_HK',
    EN_PH = 'EN_PH',
    EN_MY = 'EN_MY',
    EN_PK = 'EN_PK',
    EN_MT = 'EN_MT',
    EN_NA = 'EN_NA',
    EN_NG = 'EN_NG',
    EN_TT = 'EN_TT',
    EN_ZW = 'EN_ZW',
    FR = 'FR',
    FR_CA = 'FR_CA',
    FR_BE = 'FR_BE',
    FR_CH = 'FR_CH',
    FR_LU = 'FR_LU',
    FR_MC = 'FR_MC',
    DE = 'DE',
    DE_AT = 'DE_AT',
    DE_CH = 'DE_CH',
    DE_LU = 'DE_LU',
    DE_LI = 'DE_LI',
    ES = 'ES',
    ES_MX = 'ES_MX',
    ES_AR = 'ES_AR',
    ES_BO = 'ES_BO',
    ES_CL = 'ES_CL',
    ES_CO = 'ES_CO',
    ES_CR = 'ES_CR',
    ES_DO = 'ES_DO',
    ES_EC = 'ES_EC',
    ES_SV = 'ES_SV',
    ES_GT = 'ES_GT',
    ES_HN = 'ES_HN',
    ES_NI = 'ES_NI',
    ES_PA = 'ES_PA',
    ES_PY = 'ES_PY',
    ES_PE = 'ES_PE',
    ES_PR = 'ES_PR',
    ES_UY = 'ES_UY',
    ES_VE = 'ES_VE',
    PT = 'PT',
    PT_BR = 'PT_BR',
    IT = 'IT',
    IT_CH = 'IT_CH',
    RU = 'RU',
    UK = 'UK',
    PL = 'PL',
    NL = 'NL',
    NL_BE = 'NL_BE',
    ZH = 'ZH',
    ZH_CN = 'ZH_CN',
    ZH_TW = 'ZH_TW',
    ZH_HK = 'ZH_HK',
    ZH_SG = 'ZH_SG',
    JA = 'JA',
    KO = 'KO',
    AR = 'AR',
    AR_SA = 'AR_SA',
    AR_EG = 'AR_EG',
    AR_DZ = 'AR_DZ',
    AR_MA = 'AR_MA',
    AR_TN = 'AR_TN',
    AR_AE = 'AR_AE',
    AR_BH = 'AR_BH',
    AR_QA = 'AR_QA',
    AR_KW = 'AR_KW',
    AR_OM = 'AR_OM',
    AR_IQ = 'AR_IQ',
    AR_LB = 'AR_LB',
    AR_SY = 'AR_SY',
    AR_JO = 'AR_JO',
    AR_PS = 'AR_PS',
    AR_YE = 'AR_YE',
    AR_SD = 'AR_SD',
    AR_LY = 'AR_LY',
    AR_MR = 'AR_MR',
    AR_SO = 'AR_SO',
    AR_DJ = 'AR_DJ',
    AR_KM = 'AR_KM',
    HI = 'HI',
    BN = 'BN',
    UR = 'UR',
    FA = 'FA',
    TR = 'TR',
    EL = 'EL',
    HE = 'HE',
    HU = 'HU',
    RO = 'RO',
    SV = 'SV',
    DA = 'DA',
    FI = 'FI',
    NO = 'NO',
    NB = 'NB',
    NN = 'NN',
    IS = 'IS',
    ET = 'ET',
    LV = 'LV',
    LT = 'LT',
    SL = 'SL',
    HR = 'HR',
    SR = 'SR',
    MK = 'MK',
    BG = 'BG',
    SQ = 'SQ',
    BS = 'BS',
    AF = 'AF',
    SW = 'SW',
    VI = 'VI',
    TH = 'TH',
    ID = 'ID',
    MS = 'MS',
    TL = 'TL',
    MY = 'MY',
    KM = 'KM',
    LO = 'LO',
    MN = 'MN',
    KA = 'KA',
    HY = 'HY',
    AZ = 'AZ',
    EU = 'EU',
    BE = 'BE',
    GL = 'GL',
    CA = 'CA',
    GA = 'GA',
    CY = 'CY',
    MT = 'MT',
    AL = 'AL',
    ZU = 'ZU',
}

export type LocalizedString = Partial<Record<Language, string>> | ItemBasicDto['name'];
export type LocalizedValue<T> = Partial<Record<Language, T>>;
export type LocalizedMedia = LocalizedValue<Media>;
